import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Products from "./components/Product";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import InnovationSection from "./components/Innovation";
import Characteristics from "./components/Charateristics";
import "./App.css"

const App = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <InnovationSection/>
      <Products />
      <Characteristics/>
      <Contact/>
      <Footer />
    </>
  );
};

export default App;
